import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const montessoriMathEducationForEducators: BlogMetaData = {
  title: '保育者のためのモンテッソーリ算数教育入門｜数教具のつながりと学びの深め方',
  description:
    'モンテッソーリ算数教育を保育士・幼稚園教諭・モンテッソーリ教師向けに解説。感覚から数量・数字・十進法・計算へ進む流れと、数教具のつながり、提示・観察・環境の視点を整理し、算数教育の学びを深めます。',
  thumbnailUrl: '/img/blog-montessori-math-education-for-educators.webp',
  filePath: buildBlogFilePath('montessori-math-education-for-educators'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
